import { Image, Grid, Paragraph } from "capitalrx-components-2.0";

import styles from "./styles.module.scss";

import FamilyImage from "@/static/images/image-family-min.png";
import CVS from "@/static/images/vendor-logos/CVS.svg?url";
import Costco from "@/static/images/vendor-logos/Costco.svg?url";
import RiteAid from "@/static/images/vendor-logos/Rite_Aid.svg?url";
import Walgreens from "@/static/images/vendor-logos/Walgreens.svg?url";
import Walmart from "@/static/images/vendor-logos/Walmart.png";

const ParticipatingPharmacies = (): JSX.Element => {
  return (
    <section className={styles.participatingPharmacies} data-testid="participating-pharmacies-section">
      <div className={styles.participatingPharmaciesWrapper}>
        <div className={styles.participatingPharmaciesTextWrapper}>
          <Image src={FamilyImage} alt="Woman and baby" ariaHidden="true" />
          <Paragraph className="sectionTitle">Find discounts for you and your loved ones at over 65,000 pharmacies nationwide</Paragraph>
        </div>
        <Grid container justifyContent="center" alignItems="center" className={styles.participatingPharmaciesLogos}>
          <Grid item colLg={2}>
            <Image src={CVS} alt="CVS Pharmacy logo" ariaHidden="true" />
          </Grid>

          <Grid item colLg={2}>
            <Image src={Walgreens} alt="Walgreens logo" ariaHidden="true" />
          </Grid>

          <Grid item colLg={1}>
            <Image src={RiteAid} alt="Rite Aid logo" ariaHidden="true" />
          </Grid>

          <Grid item colLg={2}>
            <Image src={Walmart} alt="Walmart Plus logo" ariaHidden="true" />
          </Grid>

          <Grid item colLg={2}>
            <Image src={Costco} alt="Costco logo" ariaHidden="true" />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ParticipatingPharmacies;
